module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    staticClass: "pa-4",
    attrs: {
      "align-center": "align-center",
      "justify-center": "justify-center"
    }
  }, [_c('v-flex', {
    staticClass: "forgot-password-form text-xs-center"
  }, [_c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "color": !_vm.$vuetify.theme.dark ? 'white' : ''
    }
  }, [_c('v-card-text', [_c('v-alert', {
    attrs: {
      "icon": "info",
      "dense": "dense",
      "text": "",
      "border": "left",
      "type": "info"
    }
  }, [_c('span', [_c('span', {
    staticClass: "font-size-11"
  }, [_vm._v("El cambio de la contraseña sera efectuado para el usuario: ")]), _c('span', {
    staticClass: "font-size-13 font-weight-700"
  }, [_vm._v(_vm._s(_vm.$route.query.email))])])]), _c('v-form', [_c('v-text-field', {
    ref: "password",
    attrs: {
      "prepend-icon": "lock",
      "label": "Ingrese nueva contraseña",
      "type": _vm.showPassword ? 'text' : 'password',
      "append-icon": !_vm.showPassword ? 'visibility' : 'visibility_off'
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _c('v-text-field', {
    ref: "password1",
    attrs: {
      "prepend-icon": "lock",
      "label": "Repetir nueva contraseña",
      "type": _vm.showPassword1 ? 'text' : 'password',
      "append-icon": !_vm.showPassword1 ? 'visibility' : 'visibility_off'
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login($event)
      },
      "click:append": function($event) {
        _vm.showPassword1 = !_vm.showPassword1
      }
    },
    model: {
      value: (_vm.repeatNewPassword),
      callback: function($$v) {
        _vm.repeatNewPassword = $$v
      },
      expression: "repeatNewPassword"
    }
  }), _c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block"
    },
    on: {
      "click": function($event) {
        return _vm.restablecer()
      }
    }
  }, [_vm._v("Cambiar mi contraseña")])], 1)], 1), _c('div', {
    staticClass: "d-flex jc-center ai-center"
  }, [_c('small', [_vm._v("¿Deseas iniciar sesión?")]), _c('v-btn', {
    staticClass: "ml-2",
    attrs: {
      "small": "small",
      "color": "secondary primary--text"
    },
    on: {
      "click": function($event) {
        return _vm.goTo('/login')
      }
    }
  }, [_vm._v("click aqui")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c8e5492","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/View_Forgot_Password_Post.vue
// module id = 489
// module chunks = 1